export default "__VITE_ASSET__D4I4EaPU__"